type TranslatedMessages = Record<string, string>;
type TranslatedMessagesResult<T> = { messages: T; errors: Array<string> };

const CACHE = new Map<string, TranslatedMessages>();

export const preloadPlacementTranslations = (
	placementId: string,
	messageLoader: () => Promise<TranslatedMessagesResult<TranslatedMessages>>,
) => {
	return messageLoader().then(function (messagesData) {
		CACHE.set(placementId, messagesData.messages);
	});
};

export const usePreloadPlacementTranslations = (id: string) => CACHE.get(id);
